// © Microsoft Corporation. All rights reserved.

import { AppType, PageType } from "@msnews/experiences-constants";

import { appEnvironment } from "../app";
import { headData } from "../app/HeadData";

/**
 * Base class for page utility functions
 */
export namespace PageUtility {

    /**
     * Returns true if the current page is the DHP
     */
    export function isDhpPage(): boolean {
        return headData.ClientSettings.pagetype === PageType.DHP;
    }

    /**
     * Returns true if the current page is the NTP
     */
    export function isNtpPage(): boolean {
        return headData.ClientSettings.pagetype === PageType.NTP;
    }

    /**
     * Returns true if five column is supported or not
     */
    export function fiveColSupported(): boolean {
        // restrict the flight to Anaheim apptype
        if (appEnvironment.AppType !== AppType.EdgeChromium) {
            return false;
        }

        const pageExperiments = appEnvironment && appEnvironment.CurrentRequestTargetScope && appEnvironment.CurrentRequestTargetScope.pageExperiments;
        if (pageExperiments && pageExperiments.length
            && (pageExperiments.indexOf("prg-fivecol") > -1
                || pageExperiments.indexOf("prg-staging") > -1
                || pageExperiments.indexOf("prg-stripecol5") > -1)) {
            return true;
        }

        return false;
    }
}